import * as React from "react";
const SvgError = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={19} height={18} fill="none" {...props}>
    <rect width={18.054} height={18} fill="#AB291A" rx={9} />
    <path stroke="#fff" d="M9.027 5v5M9.027 12v1" />
  </svg>
);
export default SvgError;
